export default {
  title: {
    en: 'There is nothing here',
  },
}
